import { Directive, input } from '@angular/core';
import { type VariantProps, cva } from 'class-variance-authority';

import { classes } from '../../../utils/src';

const badgeVariants = cva(
  'group/badge focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent font-mono font-medium whitespace-nowrap transition-all focus-visible:ring-[3px] [&>ng-icon]:pointer-events-none',
  {
    variants: {
      color: {
        none: 'border-border bg-background text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground',

        lightgreen: 'bg-green-100 text-green-800',
        lightblue: 'bg-blue-100 text-blue-800',
        lightpurple: 'bg-purple-100 text-purple-800',
        lightred: 'bg-red-100 text-red-800',
        lightorange: 'bg-orange-100 text-orange-800',
        lightyellow: 'bg-yellow-100 text-yellow-800',
        lightlime: 'bg-lime-100 text-lime-800',
        lightgray: 'bg-gray-100 text-gray-800',

        green: 'bg-green-500 text-white',
        blue: 'bg-blue-500 text-white',
        purple: 'bg-purple-500 text-white',
        red: 'bg-red-500 text-white',
        orange: 'bg-orange-500 text-white',
        yellow: 'bg-yellow-500 text-white',
        lime: 'bg-lime-500 text-white',
        gray: 'bg-gray-500 text-white',
      },
      size: {
        sm: 'text-2xs h-4 px-1.5 py-0.75 has-data-[icon=inline-end]:pe-1.5 has-data-[icon=inline-start]:ps-1.5 [&>ng-icon]:text-[length:--spacing(2)]',
        md: 'h-5 px-2 py-0.5 text-xs has-data-[icon=inline-end]:pe-1.5 has-data-[icon=inline-start]:ps-1.5 [&>ng-icon]:text-[length:--spacing(3)]',
      },
    },
    defaultVariants: {
      size: 'md',
      color: 'none',
    },
  },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;

export type BadgeColor = BadgeVariants['color'];

export const badgeColor = (color: string): BadgeColor => {
  return color as BadgeColor;
};

@Directive({
  selector: '[knxBadge],knx-badge',
  host: {
    'data-slot': 'badge',
    '[attr.data-color]': 'color()',
  },
})
export class KnxBadge {
  public readonly color = input<BadgeVariants['color']>('none');
  public readonly size = input<BadgeVariants['size']>('md');

  constructor() {
    classes(() => {
      return badgeVariants({
        color: this.color(),
        size: this.size(),
      });
    });
  }
}
